export default __webpack_public_path__ + "static/media/seqproj.3f28e6e8.png";